var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 166,
    viewBox: "0 0 249 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24219 15.4551V150.659L72.8443 83.0571L5.24219 15.4551Z",
    fill: "#5AC994"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6699 1.91797L104.255 87.5034C115.064 98.3124 133.916 98.3124 144.725 87.5034L230.31 1.91797H18.6699Z",
    fill: "#5AC994"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.235 100.971C149.239 109.977 137.256 114.948 124.51 114.948C111.765 114.948 99.7822 109.977 90.7857 100.971L86.3495 96.5352L18.8047 164.08H230.216L162.671 96.5352L158.235 100.971Z",
    fill: "#5AC994"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176.158 83.0571L243.76 150.659V15.4551L176.158 83.0571Z",
    fill: "#5AC994"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.3e003d154be49c851df9e7fef09a1e26.svg";
export { ForwardRef as ReactComponent };